import {
  Accessibility,
  AirVent,
  AlarmClock,
  Armchair,
  Baby,
  Bath,
  BedDouble,
  Blinds,
  BriefcaseBusiness,
  Bus,
  Car,
  Caravan,
  Cigarette,
  CigaretteOff,
  CircleDot,
  Coffee,
  CookingPot,
  Disc3,
  DoorClosed,
  Droplets,
  Dumbbell,
  Eye,
  Fan,
  Fence,
  Flame,
  FlipHorizontal2,
  Flower2,
  Gamepad2,
  Gift,
  GlassWater,
  Heart,
  Heater,
  Key,
  Lamp,
  Landmark,
  Languages,
  Laptop,
  Lock,
  type LucideIcon,
  Microwave,
  Monitor,
  Motorbike,
  Mountain,
  Newspaper,
  PawPrint,
  Pen,
  Phone,
  Plug,
  Printer,
  Radio,
  Receipt,
  Refrigerator,
  RockingChair,
  Sailboat,
  Scale,
  ShieldCheck,
  Shirt,
  ShirtIcon,
  ShowerHead,
  Siren,
  Snowflake,
  Sofa,
  Sparkles,
  Sprout,
  SquareParking,
  StickyNote,
  Sun,
  Sunrise,
  Tent,
  ThermometerSun,
  Tv,
  Umbrella,
  User,
  UtensilsCrossed,
  Volume2,
  WashingMachine,
  Waves,
  Wifi,
  Wind,
} from "lucide-react";

const iconKeywords: [string[], LucideIcon][] = [
  // Room basics
  [["minibar", "mini bar", "hladnjak", "refrigerator", "fridge", "kühlschrank", "frigorifero"], Refrigerator],
  [["klima", "air condition", "klimaanlage", "climatisation"], AirVent],
  [["grijanj", "heating", "heizung", "riscaldamento", "radijator"], Heater],
  [["podnog", "floor heating", "fußbodenheizung", "riscaldamento a pavimento"], ThermometerSun],
  [["hlađenj", "cooling", "kühlung", "raffreddamento"], Snowflake],
  [["zvučno", "soundproof", "schallisoliert", "insonori"], Volume2],
  [["nepušač", "no smoking", "nichtraucher", "non fumator"], CigaretteOff],
  [["pušenj", "smoking allowed", "rauchen erlaubt"], Cigarette],
  [["ventilator", "ceiling fan", "deckenventilator", "ventilatore"], Fan],
  [["kamin", "fireplace", "kaminofen", "camino"], Flame],
  [["susjedn", "povezan", "adjoin", "connect", "verbunden"], DoorClosed],

  // Bathroom
  [["hidromasažn", "whirlpool", "jacuzzi", "hot tub", "spray jet", "mlaznic"], Bath],
  [["kombinacija kade", "bath and shower", "badewanne und dusche"], ShowerHead],
  [["odvojena kada", "separate bath", "separate badewanne"], Bath],
  [["samo tuš", "shower only", "nur dusche"], ShowerHead],
  [["tuš", "shower", "dusche", "doccia"], ShowerHead],
  [["bide", "bidet"], ShowerHead],
  [["kada", "bathtub", "badewanne", "vasca"], Bath],
  [["ogrtač", "bathrobe", "bademantel", "accappatoio"], Bath],
  [["papuč", "slipper", "pantoffel", "pantofol"], BedDouble],
  [["sušilo", "hair dryer", "haartrockner", "asciugacapelli", "fön"], Wind],
  [["kozmetičk", "cosmetic", "toilettenartikel", "cosmetici", "amenities"], Droplets],
  [["ogledalo", "mirror", "spiegel", "specchio"], FlipHorizontal2],
  [["umivaonik", "sink", "waschbecken", "lavandino"], Droplets],
  [["kupaonic", "bathroom", "badezimmer", "bagno"], Bath],
  [["vaga", "scale", "waage", "bilancia"], Scale],
  [["wc", "toilet", "toilette", "gabinetto"], DoorClosed],

  // Technology & connectivity
  [["wifi", "internet", "wlan", "wi-fi", "bežičn"], Wifi],
  [["telefon", "phone", "telefono"], Phone],
  [["poziv", "call", "anruf", "chiamat"], Phone],
  [["glasovna pošta", "voicemail", "mailbox", "segreteria"], Phone],
  [["kabelska", "satelit", "cable", "satellite", "kabel"], Tv],
  [["televizor", "television", "tv", "fernseher", "televisore"], Monitor],
  [["radio", "am/fm"], Radio],
  [["računalo", "computer", "rechner"], Laptop],
  [["pisač", "printer", "drucker", "stampante"], Printer],
  [["kopirni", "copier", "kopierer", "copiatrice"], Printer],
  [["faks", "fax", "telefax"], Printer],
  [["dvd", "dvr", "blu-ray", "cd player", "disc"], Disc3],
  [["igrač", "konzol", "video igr", "game console", "spielkonsole"], Gamepad2],
  [["film", "movie", "video na zahtjev", "on demand"], Monitor],
  [["ipod", "priključna ploča", "dock"], Plug],
  [["punjač", "charger", "usb", "power outlet", "steckdose", "presa"], Plug],
  [["hairdryer", "sušilo za kosu"], Plug],

  // Furniture & workspace
  [["stolic", "chair", "stuhl", "sedia"], Armchair],
  [["sjedenje", "sitting", "sitzbereich", "seduta"], Armchair],
  [["sofa", "kauč", "couch", "divano"], Sofa],
  [["radni stol", "desk", "schreibtisch", "scrivania", "radno područje"], Lamp],
  [["ležaljk", "sunbed", "sun lounger", "sonnenliege", "lettino", "recliner", "naslonjač"], RockingChair],
  [["ormar", "wardrobe", "closet", "kleiderschrank", "armadio"], DoorClosed],

  // Bedding
  [
    ["dječji krevet", "child bed", "children bed", "kinderbett", "lettino bambini", "baby bed", "crib bed"],
    Baby,
  ],
  [["krevet", "bed", "bett", "letto", "futon"], BedDouble],
  [["jastuc", "jastuk", "pillow", "kissen", "cuscino"], BedDouble],
  [["posteljin", "bedding", "linen", "bettwäsche", "biancheria"], BedDouble],
  [["pokrivač", "blanket", "decke", "coperta"], BedDouble],
  [["nadmadrac", "mattress", "matratze", "materasso"], BedDouble],
  [["pomoćni ležaj", "rollaway", "extra bed", "zustellbett"], BedDouble],

  // Food & beverage
  [["kavu", "kava", "čaj", "coffee", "tea", "kaffee", "tee", "caffè"], Coffee],
  [["vruća voda", "hot water", "heißes wasser", "acqua calda", "kettle"], Coffee],
  [["flaširana", "bottled water", "flaschenwasser", "acqua in bottiglia"], GlassWater],
  [["doručak", "breakfast", "frühstück", "colazione", "meal", "obrok", "swedish buffet"], UtensilsCrossed],
  [["jelovnik", "menu", "menü", "menù"], UtensilsCrossed],
  [["bar s pić", "wet bar", "drinks bar"], Coffee],

  // Kitchen & cooking
  [["kuhinja", "kuhinjsk", "kitchen", "küche", "cucina"], CookingPot],
  [["mikrovalna", "microwave", "mikrowelle", "microonde"], Microwave],
  [["pećnica", "oven", "ofen", "forno", "štednjak", "stove", "herd", "fornello"], CookingPot],
  [["toster", "toaster"], CookingPot],
  [
    ["tanjur", "zdjel", "lonci", "tave", "čaš", "pribor za jelo", "plate", "bowl", "cutlery"],
    UtensilsCrossed,
  ],

  // Outdoor & views
  [["balkon", "terasa", "lanai", "balcony", "terrace", "terrasse", "terrazza"], Fence],
  [["pogled na more", "sea view", "meerblick", "vista mare", "ocean view"], Sunrise],
  [["pogled na planin", "mountain view", "bergblick", "vista montagn"], Mountain],
  [["pogled", "view", "aussicht", "vista", "panoram"], Eye],
  [["garden", "vrt", "garten", "giardino"], Flower2],
  [["sunčalište", "sundeck", "solarium", "sunbath"], Sun],
  [["vanjski prostor", "outdoor", "außenbereich", "esterno"], Fence],
  [["roštilj", "bbq", "grill", "barbecue"], Flame],

  // Water & boating
  [["boat", "brod", "čamac", "boot", "barca", "sailing", "jedrilica", "yacht", "jahta"], Sailboat],

  // Camping & vehicles
  [["šator", "tent", "zelt", "po osobi", "per person", "pro person", "a persona", "camping"], Tent],
  [["kamper", "camper", "wohnmobil", "campervan", "motorhome"], Caravan],
  [["prikolica", "trailer", "anhänger", "rimorchio"], Caravan],
  [["autobus", "bus", "autocar", "minibus"], Bus],
  [["motocikl", "motocicletta", "motorrad", "motor", "motorcycle", "motorbike", "scooter"], Motorbike],

  // Wellness & recreation
  [["bazen", "pool", "schwimmbad", "piscina"], Waves],
  [["sauna", "spa", "wellness"], Flame],
  [["teretana", "gym", "fitness", "fitnessstudio", "palestra"], Dumbbell],

  // Laundry & clothing
  [["glačalo", "glačanj", "iron", "bügeleisen", "ferro da stiro", "peglanje"], ShirtIcon],
  [["preša za hlače", "trouser press", "bügelpress"], ShirtIcon],
  [["perilica", "washing machine", "waschmaschine", "lavatrice", "laundry", "pranje"], WashingMachine],
  [["košara za rublje", "laundry basket", "wäschekorb"], WashingMachine],
  [["kemijsko", "dry clean", "chemische reinigung", "lavaggio a secco"], Shirt],
  [["cipel", "shoe", "schuh", "scarpa", "poliranje"], Shirt],

  // Booking fees (must precede Security & access so "check-in fee" doesn't match the Key entry's "check-in")
  [["prijavna naknada", "check in fee", "check-in fee", "anmeldegebühr"], Receipt],
  [
    ["rezervacijska naknada", "naknada za rezervaciju", "reservation fee", "booking fee", "buchungsgebühr"],
    Receipt,
  ],

  // Security & access
  [["sef", "safe", "tresor", "cassaforte"], ShieldCheck],
  [
    [
      "ključ",
      "key",
      "schlüssel",
      "chiave",
      "keyless",
      "self check",
      "check-in",
      "registracij",
      "registration",
      "jednokratna prijava",
    ],
    Key,
  ],
  [["zaključ", "lock", "schloss", "serratura", "deadbolt"], Lock],
  [["detektor", "smoke detector", "fire detector", "rauchmelder", "rilevatore"], Siren],

  // Services
  [["buđenje", "budilica", "wake", "weckruf", "sveglia"], AlarmClock],
  [
    ["čišćenj", "završno čišćenje", "final cleaning", "cleaning", "reinigung", "pulizia", "housekeeping"],
    Sparkles,
  ],
  [["transfer", "shuttle", "airport", "prijevoz", "additional car"], Car],
  [["kofer", "luggage", "gepäck", "bagagli", "storage"], BriefcaseBusiness],
  [["prijevod", "translation", "übersetzung", "traduzion", "multilingual"], Languages],
  [["parking", "parkplatz", "parcheggio", "garaž", "garage"], SquareParking],
  [["poklon", "welcome gift", "willkommensgeschenk", "first nighter"], Gift],
  [["novine", "newspaper", "zeitung", "giornale"], Newspaper],

  // Taxes & fees
  [
    ["boravišna pristojba", "tourist tax", "city tax", "kurtaxe", "tassa di soggiorno", "taxe de séjour"],
    Landmark,
  ],
  [["porez", "pristojba", "tax", "steuer", "tassa", "taxe", "imposta"], Landmark],

  // Room types & features
  [["zastor", "curtain", "vorhang", "tenda", "blackout", "zatamnjiv"], Blinds],
  [["prozor", "window", "fenster", "finestra"], Eye],
  [["invalid", "accessible", "wheelchair", "barrierefrei", "accessibil"], Accessibility],
  [["alergen", "hipoalerg", "allergy", "allergi"], Sparkles],
  [["adult", "odrasl"], User],
  [["obitelj", "family", "familie", "famiglia"], Baby],
  [["bračni", "bridal", "honeymoon", "hochzeit"], Heart],
  [["kućni ljubim", "pet", "haustiere", "animali domestici"], PawPrint],

  // Family
  [
    [
      "djeca",
      "dječj",
      "baby",
      "child",
      "kinder",
      "bambini",
      "krevetić",
      "cot",
      "crib",
      "bebe",
      "vrtić",
      "nursery",
    ],
    Baby,
  ],

  // Eco
  [["organsk", "eco", "organic", "bio", "ökologisch"], Sprout],

  // Stationery & misc
  [["note", "bilježk", "notiz"], StickyNote],
  [["olovk", "pen", "stift", "penna"], Pen],
  [["pribor za ured", "office", "bürobedarf"], Pen],
  [["kišobran", "umbrella", "regenschirm", "ombrello"], Umbrella],
  [["sat", "clock", "uhr", "orologio", "alarm"], AlarmClock],
  [["molitv", "prayer", "gebet", "preghiera"], CircleDot],
  [["pročišćav", "purification", "wasserreinigung"], GlassWater],
  [["filtracija", "air filtration", "luftfilter", "filtrazion"], AirVent],
  [["naknada", "surcharge", "zuschlag", "supplemento"], CircleDot],
];

export const getIconByKeyword = (name: string): LucideIcon => {
  const lower = name.toLowerCase();
  for (const [keywords, icon] of iconKeywords) {
    if (keywords.some((kw) => lower.includes(kw))) return icon;
  }
  return CircleDot;
};
